import { lazy, Suspense } from 'react';

const ComprasScanChip = lazy(() => import('./scan-chip').then((module) => ({ default: module.ComprasScanChip })));

/** The scanning line above every screen: its code loads apart from the entry chunk. */
export function ComprasScanStatus(props: Readonly<{ ready: boolean; disabled: boolean; here: boolean; onShow: () => void }>) {
  return <Suspense fallback={null}><ComprasScanChip {...props} /></Suspense>;
}
